import { render, staticRenderFns } from "./prd_check.vue?vue&type=template&id=551a6650&scoped=true&"
import script from "./prd_check.vue?vue&type=script&lang=js&"
export * from "./prd_check.vue?vue&type=script&lang=js&"
import style0 from "./prd_check.vue?vue&type=style&index=0&id=551a6650&scoped=true&lang=less&"
import style1 from "./prd_check.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a6650",
  null
  
)

export default component.exports